import React from 'react';
import { CalendarMonth, EventAvailable, RestaurantMenu } from '@mui/icons-material';

const formatInput = (date) => date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10) : '';
const fromInput = (value) => value ? new Date(`${value}T00:00:00`) : null;

export default function ShoppingListDateStepV2({ startDate, endDate, setStartDate, setEndDate, summary }) {
  const setRange = (offset, length = 6) => {
    const start = new Date(); start.setDate(start.getDate() + offset); start.setHours(0, 0, 0, 0);
    const end = new Date(start); end.setDate(end.getDate() + length);
    setStartDate(start); setEndDate(end);
  };
  const setWeek = (next = false) => {
    const start = new Date(); const day = start.getDay() || 7; start.setDate(start.getDate() - day + 1 + (next ? 7 : 0)); start.setHours(0, 0, 0, 0);
    const end = new Date(start); end.setDate(end.getDate() + 6); setStartDate(start); setEndDate(end);
  };
  return <section className="list-creator-v2-step list-date-v2">
    <div className="list-creator-v2-copy"><span>Paso 1 de 3</span><h2>¿Para qué días vas a comprar?</h2><p>Usaremos tu menú planificado para calcular sólo lo que necesitas.</p></div>
    <div className="list-date-v2-layout">
      <div className="list-date-v2-picker">
        <div className="list-date-v2-inputs">
          <label><span>Desde</span><div><CalendarMonth /><input type="date" value={formatInput(startDate)} onChange={(event) => setStartDate(fromInput(event.target.value))} /></div></label>
          <span className="list-date-v2-arrow">→</span>
          <label><span>Hasta</span><div><EventAvailable /><input type="date" min={formatInput(startDate)} value={formatInput(endDate)} onChange={(event) => setEndDate(fromInput(event.target.value))} /></div></label>
        </div>
        <div className="list-date-v2-shortcuts"><button onClick={() => setWeek(false)}>Esta semana</button><button onClick={() => setRange(0)}>Próximos 7 días</button><button onClick={() => setWeek(true)}>Próxima semana</button></div>
      </div>
      <aside className={`list-date-v2-summary ${summary?.meals === 0 ? 'has-warning' : ''}`}><RestaurantMenu /><div><span>Tu planificación</span><strong>{summary ? `${summary.meals} comidas en ${summary.days} días` : 'Buscando tus comidas…'}</strong><small>{summary?.meals === 0 ? 'No hay comidas planificadas en este rango.' : 'La lista se ajustará a las recetas y raciones.'}</small></div></aside>
    </div>
  </section>;
}
